import { useIntl } from "react-intl";
import { WmModal, WmModalFooter, WmModalHeader } from "@watermarkinsights/ripple-react";

interface ClearConversationModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ClearConversationModal = ({
  isOpen,
  onCancel,
  onConfirm,
}: ClearConversationModalProps) => {
  const intl = useIntl();

  return (
    <WmModal
      open={isOpen}
      id="tcw-clear-conversation-modal"
      uid="tcw-clear-conversation-modal"
      elementToFocus="secondary"
      modalType="dialog"
      aria-label={intl.formatMessage({
        id: "app.toolboxChat.clearConversationModal.heading",
      })}
      onWmModalCloseTriggered={onCancel}
      onWmModalSecondaryTriggered={onCancel}
      onWmModalPrimaryTriggered={onConfirm}
    >
      <WmModalHeader
        heading={intl.formatMessage({
          id: "app.toolboxChat.clearConversationModal.heading",
        })}
      ></WmModalHeader>
      <div id="content-tcw-clear-conversation-modal">
        <p>
          {intl.formatMessage({ id: "app.toolboxChat.clearConversationModal.body" })}
        </p>
      </div>
      <WmModalFooter
        primaryText={intl.formatMessage({
          id: "app.toolboxChat.clearConversationModal.primaryText",
        })}
        secondaryText={intl.formatMessage({
          id: "app.toolboxChat.clearConversationModal.secondaryText",
        })}
        deleteStyle={true}
      ></WmModalFooter>
    </WmModal>
  );
};
